(function ($) {$(function(){
    const modal = $('#video-modal');
    const videoContainer = $('.video-modal-container');
    const worksList = $('a.home-video-link.home-player-link');
    const videoCloseBtn = $('#video-close-btn');
    const videoHeader = $('.video-info-header');
    const videoTitle = $('#video-title');
    const videoSubtitle = $('#video-subtitle');
    const playerOptions = {
        iconUrl: window.wpkai_config.theme_dir_uri + '/resources/img/icons/player-icons.svg',
        settings: [],
        controls: [
            'play', // Play/pause playback
            'progress', // The progress bar and scrubber for playback and buffering
            'settings', // Settings menu
            'mute', // Toggle mute
            'fullscreen', // Toggle fullscreen
          ],
    };

    videoCloseBtn.on('click', function (e) {
        modal.removeClass('active');
        directorVideoPlayer.stop();
    });
    worksList.on('click', function (e) {
        const $this = $(this);
        if($this.attr('id') == 'open-director-gallery') return;
        e.preventDefault();
        videoTitle.html($this.data('video-subtitle'))
        videoSubtitle.html($this.data('video-title'))
        const videoElement = $(`<div id="video-player" data-plyr-provider="vimeo" data-plyr-embed-id="${$this.data('video-id')}"></div>`);
        modal.addClass('active');
        videoContainer.empty();
        videoContainer.append(videoElement);
        window.directorVideoPlayer = new Plyr('#video-player', playerOptions);
        directorVideoPlayer.on('controlsshown', function () {
            videoHeader.addClass('active')
        })
        directorVideoPlayer.on('controlshidden', function () {
            videoHeader.removeClass('active')
        })
        directorVideoPlayer.on('ready', function () {
            directorVideoPlayer.play();
        })
    });
});}(_jQ3));